'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _preludeExtension = require('prelude-extension');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _regions = require('redux/modules/regions');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegionBox = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { search: _regions.search }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(RegionBox, _Component);

  function RegionBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RegionBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegionBox.__proto__ || (0, _getPrototypeOf2.default)(RegionBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false,
      loaded: false,
      options: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RegionBox, [{
    key: 'onSearchChange',
    value: function onSearchChange(input) {
      var _this2 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        ajax: setTimeout(function () {
          _this2.loadRegions(query);
        }, 250),
        loaded: false
      });
    }
  }, {
    key: 'filterOptions',
    value: function filterOptions(options, values, query) {
      return options.filter(function (option) {
        var inValues = values.filter(function (value) {
          if (value) {
            return option.value === value.value;
          }
          return true;
        });
        var label = (0, _unidecode2.default)(option.label).toLowerCase().trim();
        var queryTyped = (0, _unidecode2.default)(query).toLowerCase().trim();
        return !inValues.length && label.indexOf(queryTyped) > -1;
      });
    }
  }, {
    key: 'loadRegions',
    value: function loadRegions(query) {
      var _this3 = this;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          _this3.props.search(query).then(function (regions) {
            var regionsRendered = regions.result.data.map(function (region) {
              return (0, _extends3.default)({}, region, {
                value: region.id,
                label: region.name,
                labelPartitions: (0, _preludeExtension.partitionString)((0, _unidecode2.default)(region.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase())
              });
            });
            _this3.setState({
              loaded: !_this3.state.ajax,
              loading: false,
              options: regionsRendered
            });
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          options: [],
          loading: false
        });
      }
    }
  }, {
    key: 'handleOnChange',
    value: function handleOnChange(selectedRegion) {
      this.props.onChange(selectedRegion);
      this.refs.regionBoxPopover.hide();
    }
  }, {
    key: 'renderNoResults',
    value: function renderNoResults(value) {
      var polyglot = this.props.polyglot;
      var loading = this.state.loading;


      if (loading) {
        return _react2.default.createElement(
          'div',
          { className: 'no-results-found', style: { fontSize: 13 } },
          polyglot.t('loading')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'no-results-found', style: { fontSize: 13 } },
        value.length === 0 ? polyglot.t('simpleSelect.typeSome') : polyglot.t('simpleSelect.noResults')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          region = _props.region,
          polyglot = _props.polyglot,
          popoverContainer = _props.popoverContainer;
      var options = this.state.options;


      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'regionBoxPopover',
          trigger: 'click',
          placement: 'bottom',
          rootClose: true,
          container: popoverContainer,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'regionBoxPopover', className: 'region-box-popover' },
            _react2.default.createElement(_reactSelect2.default, {
              className: 'react-select',
              classNamePrefix: 'react-select',
              placeholder: polyglot.t('simpleSelect.typeSome'),
              onInputChange: this.onSearchChange.bind(this),
              options: options,
              noOptionsMessage: this.renderNoResults.bind(this),
              value: region,
              onChange: this.handleOnChange.bind(this),
              autoFocus: true
            })
          )
        },
        region ? _react2.default.createElement(RegionBox.Region, {
          polyglot: polyglot,
          region: region,
          errors: errors
        }) : _react2.default.createElement(RegionBox.Empty, { polyglot: polyglot })
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var polyglot = _ref2.polyglot,
          onClick = _ref2.onClick;

      return _react2.default.createElement(
        'div',
        { className: 'dashed-box region-box empty', onClick: onClick },
        _react2.default.createElement('span', { className: 'icon-cg-group left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('regionBox.title')
        )
      );
    }
  }, {
    key: 'Region',
    value: function Region(_ref3) {
      var polyglot = _ref3.polyglot,
          region = _ref3.region,
          onClick = _ref3.onClick,
          errors = _ref3.errors;

      return _react2.default.createElement(
        'div',
        { className: 'line-box region-box has-region' + (errors ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement(
          'h3',
          { className: 'box-header' },
          polyglot.t('regionBox.title')
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-content text-center' },
          region.logo_url ? _react2.default.createElement('img', { id: 'image-placeholder', src: region.logo_url, width: '100%', height: '100%' }) : '',
          _react2.default.createElement(
            'p',
            null,
            region.name
          )
        )
      );
    }
  }]);
  return RegionBox;
}(_react.Component), _class2.propTypes = {
  errors: _propTypes2.default.any,
  onChange: _propTypes2.default.func.isRequired,
  region: _propTypes2.default.object,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  search: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = RegionBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/RegionBox.js
// module id = 2221
// module chunks = 0